/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @typescript-eslint/quotes */
import {
  Avatar,
  Button,
  Icon as ChakraIcon,
  Circle,
  Divider,
  Flex,
  FormControl,
  Heading,
  IconButton,
  InputRightElement,
  Tag,
  Text,
  useDisclosure,
  Box,
  Checkbox,
  List,
  ListItem,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Portal,
  Tooltip,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { BsEmojiSmile, BsPeopleFill } from 'react-icons/bs';
import { BiBlock } from 'react-icons/bi';
import {
  FiMic,
  FiMicOff,
  FiPlus,
  FiSend,
  FiSmile,
  FiX,
  FiUsers,
  FiUserPlus,
} from 'react-icons/fi';
import { IoShieldCheckmarkSharp } from 'react-icons/io5';
import { FaMicrophone } from 'react-icons/fa';
import { Picker } from 'emoji-mart';
import { useQueryClient } from 'react-query';
import { showNotification } from '../../notification';
import * as Constants from '../../../constants';
import BlgButton from '../../../components/Button/Button';
import BlgSelect from '../../../components/Select';
import BlgInput from '../../../components/Input';
import 'emoji-mart/css/emoji-mart.css';
import { NewDrawerProps } from '../../../@types';
import { useRole } from '../../../hooks';
import {
  useNewSonarGroupMessage,
  useSonarGroupMessages,
  SONAR_CACHE_KEYS,
  useConnections,
  useJoinGroup,
  useDeclineInvite,
  useMute,
  useSonarInvite,
} from '../../../api';
import {
  SonarAcceptModal,
  SonarAddUsersModal,
  SonarChat,
} from '../../toolbar/Sonar';

const Styles = {
  GroupName: {
    fontWeight: 'semibold',
    bg: 'blue.50',
    my: 3,
    py: 3,
    px: 6,
    rounded: 'full',
    letterSpacing: 'tight',
    fontSize: 'md',
  },
};

interface iMessages {
  id: number;
  user: string;
  avatar: string;
  message: string;
  date: string;
  isYou: boolean;
}

interface EpisodeDashboardProps {
  sonarGroups?: any;
  isLoading?: boolean;
}

interface PickerOption {
  label: string;
  value: string;
  selected?: boolean;
  children?: PickerOption[];
}

interface GroupMemberListProps {
  userId: string;
  group: any;
  episodeId: string;
  isModerator?: boolean;
}
const GroupMemberList: React.FC<GroupMemberListProps> = ({
  userId,
  group,
  episodeId,
  isModerator = false,
}) => {
  const { group_members: members }: { group_members: any[] } = group;
  const [mutingMemberId, setMutingMemberId] = useState<any>(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    mutateAsync: toggleMute,
    isLoading: toggleMuteLoading,
    error: toggleMuteError,
  } = useMute(group.episode_id, group.id);

  const sortedMembers = members.sort((a, b) => {
    return a.user.user_role_id - b.user.user_role_id;
  });
  const firstStudent = sortedMembers.findIndex(
    ({ user }) => user.user_role_id === Constants.USER_ROLES.STUDENT
  );
  const showDivider =
    group.group_type === Constants.SONAR_GROUP_TYPES.CLASSROOM;

  const handleMute = async ({ memberId, isMuted }: any) => {
    setMutingMemberId(memberId);
    await toggleMute({
      group_id: group.id,
      group_member_id: memberId,
      status: isMuted
        ? Constants.SONAR_GROUP_MEMBER_STATUS.MUTED
        : Constants.SONAR_GROUP_MEMBER_STATUS.ACCEPTED,
    });
    const memberIndex = members.findIndex(
      (member: any) => member.id === memberId
    );
    members[memberIndex].status = isMuted
      ? Constants.SONAR_GROUP_MEMBER_STATUS.MUTED
      : Constants.SONAR_GROUP_MEMBER_STATUS.ACCEPTED;
    setMutingMemberId(false);
  };
  return (
    <>
      <Popover isLazy placement="left">
        <PopoverTrigger>
          <Flex pr={10} pt={2} position="relative">
            <ChakraIcon
              fontSize={20}
              as={BsPeopleFill}
              _hover={{
                bg: 'white',
                color: 'primary.500',
              }}
              cursor="pointer"
            />
            {group?.id && (
              <Flex
                bg="newGreen.500"
                borderRadius="full"
                alignItems="center"
                justifyContent="center"
                w={3.5}
                h={3.5}
                color="white"
                fontWeight={600}
                fontSize={8}
                position="absolute"
                right={8}
                top={1}
              >
                {group?.group_members?.length}
              </Flex>
            )}
          </Flex>
          {/* <IconButton
            variant="ghost"
            mr={4}
            pl={2}
            pr={2}
            h={10}
            size="sm"
            aria-label="Member List"
            bg="none"
            icon={
              <>
                <Text fontSize="xs" position="relative" top="-5px">
                  {members.length}
                </Text>
                <ChakraIcon boxSize={5} as={FiUsers} />
              </>
            }
            onClick={(e) => e.stopPropagation()}
            _hover={{
              bg: 'white',
              color: 'primary.500',
            }}
          /> */}
        </PopoverTrigger>
        <Portal>
          <PopoverContent
            onClick={(e) => e.stopPropagation()}
            maxH="350px"
            boxShadow="2xl"
            overflowY="scroll"
            textAlign="left"
          >
            <PopoverArrow />
            <PopoverHeader
              as={Flex}
              alignItems="center"
              justifyContent="space-between"
              minH={14}
              color="white"
              bg="newGreen.600"
              textAlign="left"
              fontWeight="medium"
            >
              Group Members
              {isModerator && (
                <Flex grow={1} justify="flex-end">
                  <IconButton
                    variant="ghost"
                    mr={3}
                    p={2}
                    h={8}
                    size="xs"
                    aria-label="Add users to group"
                    onClick={onOpen}
                    _hover={{ bg: '#ffffff26' }}
                    icon={
                      <ChakraIcon boxSize={5} color="white" as={FiUserPlus} />
                    }
                  />
                </Flex>
              )}
              <PopoverCloseButton
                color="gray.50"
                bg="#ffffff26"
                position="static"
              />
            </PopoverHeader>
            <PopoverBody px={0}>
              <List pl={0} pt={2} spacing={2}>
                {!!sortedMembers.length &&
                  sortedMembers.map((member, i) => {
                    const { user } = member;
                    const isSelf = user.id === userId;
                    const isMuted =
                      member.status ===
                      Constants.SONAR_GROUP_MEMBER_STATUS.MUTED;
                    const showModerator =
                      group.group_type ===
                        Constants.SONAR_GROUP_TYPES.CLASSROOM &&
                      user.user_role_id === Constants.USER_ROLES.TEACHER;
                    return (
                      <ListItem key={member.id}>
                        {showDivider && i === firstStudent && <Divider />}
                        <Flex
                          bg={isMuted ? '#fdf5f5' : 'white'}
                          {...(showModerator && {
                            bg:
                              'linear-gradient(275deg, #36af6e14 0%, transparent 60%)',
                            fontWeight: 'semibold',
                          })}
                          py={2}
                          px={4}
                          align="center"
                        >
                          <Avatar
                            size="sm"
                            name={user.username}
                            src={`${user.avatar}`}
                            mr={3}
                            opacity={isMuted ? 0.2 : 1}
                          />
                          <Box flexGrow={1}>
                            <Flex align="center">
                              <Text opacity={isMuted ? 0.5 : 1}>
                                {user.username}
                              </Text>
                              {user.id === userId && (
                                <Text className="me">You</Text>
                              )}
                              {showModerator && (
                                <Flex flexGrow={1} justify="flex-end">
                                  <Circle
                                    rounded="lg"
                                    color="green.400"
                                    bg="none"
                                    mr={1}
                                  >
                                    <ChakraIcon
                                      boxSize={7}
                                      as={IoShieldCheckmarkSharp}
                                    />
                                  </Circle>
                                </Flex>
                              )}
                              {isModerator && !isSelf && !showModerator && (
                                <Flex flexGrow={1} justify="flex-end">
                                  <Tooltip
                                    label={isMuted ? 'Unmute' : 'Mute'}
                                    shouldWrapChildren
                                  >
                                    <IconButton
                                      rounded="full"
                                      size="sm"
                                      variant="outline"
                                      bg={isMuted ? 'red.50' : 'white'}
                                      aria-label="Toggle Mute"
                                      isLoading={
                                        toggleMuteLoading &&
                                        member.id === mutingMemberId
                                      }
                                      onClick={() =>
                                        handleMute({
                                          memberId: member.id,
                                          isMuted: !isMuted,
                                        })
                                      }
                                      {...{
                                        colorScheme: isMuted ? 'red' : 'gray',
                                        color: isMuted ? 'red.500' : 'gray.700',
                                      }}
                                      icon={
                                        <ChakraIcon
                                          boxSize={4}
                                          as={isMuted ? FiMicOff : FiMic}
                                        />
                                      }
                                    />
                                  </Tooltip>
                                </Flex>
                              )}
                            </Flex>
                          </Box>
                        </Flex>
                      </ListItem>
                    );
                  })}
              </List>
            </PopoverBody>
          </PopoverContent>
        </Portal>
      </Popover>
      {isOpen && isModerator && (
        <SonarAddUsersModal
          isAddUsersModalOpen={isOpen}
          onCloseAddUsersModal={onClose}
          Styles={Styles}
          group={group}
          episodeId={episodeId}
        />
      )}
    </>
  );
};

export const EpisodeChat = ({
  onClose: onChatClose,
  isOpen: isChatOpen,
  isLoading,
  sonarGroups,
  user,
  episodeId,
}: NewDrawerProps & EpisodeDashboardProps) => {
  const queryClient = useQueryClient();
  const { userRole } = useRole();
  const { isTeacher = false, isAdmin = false } = userRole || {};
  const [groups, pending] = sonarGroups || [];
  const { data: { connections, classrooms } = {} } = useConnections();
  const [acceptingInvite, setAcceptingInvite] = useState<any>(false);
  const [pickerList, setPickerList] = useState<PickerOption[]>([]);
  const [selectedPicks, setSelectedPicks] = useState<string[]>([]);
  const [groupName, setGroupName] = useState('');
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isAcceptInviteModalOpen,
    onOpen: onOpenAcceptInviteModal,
    onClose: onCloseAcceptInviteModal,
  } = useDisclosure();

  const {
    mutate: joinGroup,
    isLoading: joinGroupLoading,
    error: joinGroupError,
  } = useJoinGroup(episodeId);

  const {
    mutateAsync: sendSonarInvite,
    status: sendInviteStatus,
  } = useSonarInvite(episodeId);

  const { mutate: declineInvite, isLoading: declineLoading } = useDeclineInvite(
    episodeId
  );

  const resetPickerOptions = () => {
    const options = [];
    if (connections && !!connections.active.length) {
      options.push({
        label: 'My Belouga Connections',
        value: '1',
        children: connections.active.map((u: any) => {
          return {
            label:
              isTeacher || isAdmin
                ? `${u.first_name} ${u.last_name} (${u.username})`
                : u.username,
            value: `ind__${u.id}`,
          };
        }),
      });
    }
    if (classrooms && isTeacher) {
      const classroomIds = Object.keys(classrooms);
      options.push({
        label: 'My Classrooms',
        value: '2',
        children: classroomIds.map((classroomId) => {
          const { classroom, users } = classrooms[classroomId];
          const classroomChildren = users.map((u: any) => {
            return {
              label: u.username,
              value: `class__${u.id}`,
            };
          });
          return {
            label: classroom.name,
            value: classroom.id,
            children: classroomChildren,
          };
        }),
      });
    }
    setPickerList([...options]);
  };

  useEffect(() => {
    if (classrooms || connections) {
      resetPickerOptions();
    }
  }, [connections, groups]);

  const handlePickerChange = (values: string[]) => {
    const newPicks = values;
    const selectedClassrooms = values.filter(
      (id) => id.indexOf('ind__') === -1 && id.indexOf('class__') === -1
    );
    if (!!selectedClassrooms?.length) {
      selectedClassrooms.forEach((parentClassroomId) => {
        const classroomStudents: string[] = [];
        const classroom =
          pickerList[1]?.children &&
          pickerList[1].children.find(
            ({ value }) => value === parentClassroomId
          );
        if (classroom?.children) {
          classroom.children.forEach((student) => {
            classroomStudents.push(student.value);
          });
          newPicks.push(...classroomStudents);
        }
      });
    }
    setSelectedPicks([...Array.from(new Set(newPicks))]);
  };

  const onCreateGroup = async () => {
    if (!!selectedPicks.length) {
      try {
        await sendSonarInvite({
          episode_id: episodeId,
          invitee_ids: selectedPicks,
          group_name: groupName,
          user_id: user.id,
        });
        showNotification({
          type: 'success',
          title: 'Sonar Sent!',
          message: "Get excited, you're about to be learning together!",
          duration: 3000,
        });
      } catch (e) {
        //
      } finally {
        onClose();
        resetPickerOptions();
        const clearBtn = document.getElementsByClassName(
          'rs-picker-toggle-clean'
        )[0] as HTMLAnchorElement;
        clearBtn?.click();
      }
    }
  };

  useEffect(() => {
    if (isChatOpen) {
      queryClient.invalidateQueries([SONAR_CACHE_KEYS.SONAR_GROUPS, episodeId]);
    }
  }, [isChatOpen]);

  const onAcceptInvite = async (invite: any) => {
    if (user.user_role_id === Constants.USER_ROLES.TEACHER) {
      setAcceptingInvite(invite);
      onOpenAcceptInviteModal();
      return;
    }
    if (user.user_role_id === Constants.USER_ROLES.STUDENT) {
      setAcceptingInvite(invite);
      await joinGroup({
        group_id: invite.id,
        invitee_ids: [],
      });
    }
  };

  const onDeclineInvite = async (invite: any) => {
    await declineInvite(invite.id);
  };

  // Old stuff below
  const [selected, setSelected] = React.useState<any>(groups?.[0] || null);
  const [text, setText] = React.useState('');
  const [messages, setMessages] = React.useState<iMessages[]>();
  const [showPicker, setShowPicker] = React.useState(false);
  const [isModerator, setIsModerator] = React.useState(false);
  const [canMessage, setCanMessage] = React.useState(true);

  const {
    data: chatMessages = [],
    isLoading: messagesLoading,
    isSuccess,
  } = useSonarGroupMessages(selected?.id);

  const handleChageGroup = (e: any) => {
    const group = groups.find((g: any) => g.id === e.target.value);
    setSelected(group);
  };

  useEffect(() => {
    if (selected) {
      const self = selected.group_members.find(
        ({ user_id }: any) => user_id === user.id
      );
      const canGroupMessage =
        self && self.status !== Constants.SONAR_GROUP_MEMBER_STATUS.MUTED;
      setCanMessage(canGroupMessage);

      const isThisModerator =
        selected.group_type === Constants.SONAR_GROUP_TYPES.CLASSROOM
          ? user.user_role_id === Constants.USER_ROLES.TEACHER
          : user.id === selected.created_by;

      setIsModerator(isThisModerator);
    }
  }, [selected]);

  const {
    mutateAsync: submitMessage,
    isLoading: newMessageLoading,
  } = useNewSonarGroupMessage(selected?.id);

  useEffect(() => {
    if (isSuccess) {
      queryClient.invalidateQueries(
        [SONAR_CACHE_KEYS.SONAR_GROUPS, selected.episode_id],
        {
          refetchInactive: true,
        }
      );
    }
  }, [isLoading]);

  useEffect(() => {
    const chats: iMessages[] = [];
    chatMessages.forEach((message: any) => {
      chats.push({
        id: message.id,
        user: message.user.username,
        avatar: message.user.avatar,
        message: message.message,
        date: message.created,
        isYou: message.user_id === user.id,
      });
    });
    if (
      chatMessages.length !== messages?.length ||
      chatMessages?.[0]?.id !== messages?.[0]?.id
    ) {
      setMessages(chats);
    }
  }, [chatMessages]);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    await submitMessage({
      group_id: selected.id,
      user_id: user.id,
      message: text,
    });
    const newMessage = {
      id: messages?.length,
      user: user.username,
      avatar: user.avatar,
      message: text,
      date: 'just now',
      isYou: true,
    };
    setMessages((old: any) => [...old, newMessage]);
    setText('');
  };
  const handleClean = () => {
    setText('');
  };
  const handleSelectEmoji = (emoji: any) => {
    setText((old) => old + emoji.native);
    setShowPicker(false);
  };

  return (
    <Flex
      flexDir="column"
      bg="darkBlue.500"
      position="absolute"
      bottom={0}
      right={12}
      borderTopRadius={12}
      overflow="hidden"
      w={600}
      zIndex={1000}
    >
      <Flex justifyContent="space-between">
        <Flex flexDir="column" lineHeight={1} p={6} color="white">
          <Text fontSize={18} fontWeight="bold">
            Sonar Chat
          </Text>
          <Text>Discuss with others in your sonar group</Text>
        </Flex>
        <IconButton
          mr={3}
          my={2}
          onClick={onChatClose}
          variant="ghost"
          aria-label="close"
          icon={<FiX />}
        />
      </Flex>
      <Flex
        flexDir="column"
        bg="white"
        gap={4}
        p={6}
        color="gray.500"
        minH={400}
      >
        <Text fontWeight={600}>My Groups ({groups?.length || 0})</Text>
        {!isLoading && !groups?.length && (
          <Text fontSize="sm" py={3} color="gray.400">
            {`You don't have any groups for this episode yet.`}
          </Text>
        )}
        {!!pending?.length && (
          <Box
            border="2px dashed"
            borderColor="blue.500"
            rounded="md"
            mb={5}
            p={4}
          >
            <Flex
              rounded="md"
              color="white"
              bg="newGreen.600"
              p={3}
              mb={4}
              align="center"
              justify="center"
            >
              <ChakraIcon mr={2} boxSize={5} as={FiSmile} />
              <Heading
                {...{
                  fontSize: 'sm',
                  fontWeight: 'medium',
                }}
              >
                Woohoo! You have pending invitations:
              </Heading>
            </Flex>

            {pending.map((invite: any) => (
              <Flex
                key={invite.id}
                flexDir="column"
                {...{
                  py: 2,
                  px: 4,
                  mb: 10,
                  ml: 2,
                  borderLeft: '4px solid',
                  borderColor: 'gray.100',
                }}
              >
                <Box>
                  <Text color="primary.500" mr={2} as="span" fontWeight="bold">
                    {invite.user.username}
                  </Text>
                  has invited you to join their group:
                  <Box {...Styles.GroupName}>{invite.name}</Box>
                </Box>
                <Flex align="center" mt={2} flexGrow={1}>
                  <Button
                    onClick={() => onAcceptInvite(invite)}
                    isLoading={joinGroupLoading}
                    colorScheme="green"
                    size="sm"
                    mr={3}
                  >
                    Join Group
                  </Button>
                  <Button
                    size="sm"
                    variant="ghost"
                    color="gray.400"
                    bg="none"
                    isLoading={declineLoading}
                    onClick={() => onDeclineInvite(invite)}
                  >
                    Decline Invite
                  </Button>
                </Flex>
              </Flex>
            ))}
          </Box>
        )}
        {!!groups?.length && selected?.id && (
          <FormControl zIndex={1}>
            <BlgSelect
              color="gray.500"
              fontWeight={500}
              fontSize={14}
              options={groups.map((g: any, i: number) => {
                return { id: i, label: g.name, value: g.id };
              })}
              onChange={handleChageGroup}
              value={selected?.id}
            />
            <InputRightElement>
              <GroupMemberList
                userId={user.id}
                group={selected}
                episodeId={episodeId}
                isModerator={isModerator}
              />
            </InputRightElement>
          </FormControl>
        )}
        {!!selected?.id && (
          <Flex
            flexDir="column"
            p={4}
            pt={8}
            bg="gray.100"
            mt={-8}
            borderBottomRadius={12}
            position="relative"
          >
            <Flex flexDir="column" gap={4} h={250} overflowY="auto">
              {messages?.map((chat: any) => (
                <Flex key={chat.id} gap={2} lineHeight={1}>
                  <Avatar src={chat.avatar} size="sm" name={chat.user} />
                  <Flex flexDir="column" borderRadius={12} gap={1}>
                    <Flex gap={2}>
                      <Text fontSize={14} fontWeight={600}>
                        {chat.user}
                      </Text>
                      {chat.isYou && (
                        <Tag
                          fontSize={8}
                          colorScheme="newGreen"
                          variant="solid"
                          size="sm"
                          py={0}
                          minH={2}
                          borderRadius="full"
                        >
                          You
                        </Tag>
                      )}
                    </Flex>

                    <Flex gap={2}>
                      <Text fontSize={12}>{chat.message}</Text>
                      <Text fontSize={10} opacity={0.5} mt={0.5}>
                        {chat.date}
                      </Text>
                    </Flex>
                  </Flex>
                </Flex>
              ))}
            </Flex>
            {canMessage ? (
              <form onSubmit={handleSubmit}>
                <FormControl>
                  <BlgInput
                    placeholder="Type a message..."
                    pr={100}
                    value={text}
                    onChange={(e: any) => setText(e.target.value)}
                  />
                  <InputRightElement
                    display="flex"
                    alignItems="center"
                    h="full"
                    pr={2}
                  >
                    {showPicker && (
                      <Box
                        position="absolute"
                        bottom={8}
                        right={0}
                        zIndex="1000"
                        onMouseLeave={() => setShowPicker(false)}
                      >
                        <Picker onSelect={handleSelectEmoji} />
                      </Box>
                    )}
                    <IconButton
                      onClick={handleClean}
                      size="sm"
                      fontSize={20}
                      aria-label="cancel message"
                      icon={<FiX />}
                      variant="ghost"
                      borderRadius="full"
                    />
                    <IconButton
                      onClick={handleSubmit}
                      size="sm"
                      fontSize={16}
                      aria-label="Send message"
                      icon={<FiSend />}
                      variant="ghost"
                      borderRadius="full"
                    />
                    {/* <IconButton
                      size="sm"
                      fontSize={16}
                      onClick={() => setShowPicker((val) => !val)}
                      aria-label="emoji message"
                      icon={<BsEmojiSmile />}
                      variant="ghost"
                      borderRadius="full"
                    /> */}
                  </InputRightElement>
                </FormControl>
              </form>
            ) : (
              <Flex
                justify="center"
                fontWeight="normal"
                w="full"
                align="center"
              >
                <ChakraIcon boxSize={6} mr={3} color="red.500" as={BiBlock} />
                You have been muted in this group.
              </Flex>
            )}
          </Flex>
        )}
      </Flex>
      {!!acceptingInvite &&
        isAcceptInviteModalOpen &&
        user.user_role_id === Constants.USER_ROLES.TEACHER && (
          <SonarAcceptModal
            isAcceptInviteModalOpen={isAcceptInviteModalOpen}
            onCloseAcceptInviteModal={onCloseAcceptInviteModal}
            Styles={Styles}
            acceptingInvite={acceptingInvite}
            classrooms={classrooms}
            episodeId={episodeId}
          />
        )}
    </Flex>
  );
};
